import { logger as garnishLogger } from '@garnish/logger';

garnishLogger.enable('CUSTOMIZATION');

export const customizationLogger = garnishLogger.extend('CUSTOMIZATION');
